import { AccountSettings } from './../../../services/api-names';
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import { Utils } from '../../../utils/utils';
import { TECH_LIB_PORTAL_CONFIG, TechLibPortalConfig } from '../../../tech-lib-portal.interceptor';
import { SessionService } from './../../../services/session.service';
import { ClientMarketingRequestModel } from '../request/models/clientmarketing-request.model';
import { GetUserBusinessAreaResponseInterface } from '../../commons/interfaces/getUserBussinessArea-response.interface';
import { GetUserBusinessAreaResponseModel } from '../../commons/models/getUserBussinessArea-response.model';
//import { GenericMessageResponseInterface } from '../response/interfaces/generic-message.interface';
//import { GenericMessageResponseModel } from '../response/models/generic-message.model';
@Injectable({
  providedIn: 'root',
})

export class AccountSettingsService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService,
    private zone: NgZone
  ) { }

/* Idioma */
  public getBusinessArea(): Observable<GetUserBusinessAreaResponseInterface> {
    const url = Utils.formatString(
      this.config.baseApi + AccountSettings.apirest_client_bussinesareacode,
      [this.config.domain]
    );

    return new Observable(
      (observer: Observer<GetUserBusinessAreaResponseModel>) => {
        this.httpClient
          .get<GetUserBusinessAreaResponseInterface>(url)
          .pipe(
            map((resp: any) => {
              return resp as GetUserBusinessAreaResponseModel;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public updateLanguage(language: string): Observable<any> {
    const url = this.config.baseApi + AccountSettings.apirest_client_language;
      const body = {
        'Language':language
        };

    return new Observable(
      (observer: Observer<any>) => {
        this.httpClient
          .post<any>(url,body)
          .pipe(
            map((resp: any) => {
              return resp as any;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  /* Commercial Comunications */
  public updateCommercialCommunications(valor: boolean): Observable<any> {
    const url =
      this.config.baseApi + AccountSettings.apirest_client_marketing;

    const body = new ClientMarketingRequestModel();
    body.AcceptEmailMarketing = valor;
    body.AcceptMarketing = valor;

    return new Observable(
      (observer: Observer<any>) => {
        this.httpClient
          .post<any>(url, body)
          .pipe(
            map((resp: any) => {
              return resp as any;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  //Password
  modifyPassword(currentPassword: string, password: string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=UTF-8');
    headers = headers.set('Tower30-SessionToken', this.config.sessionToken);
    headers = headers.set('Tower30-ClientCode', this.config.clientCode);
    headers = headers.set('Tower30-Domain', this.config.domain);
    headers = headers.set('Tower30-Language', this.config.language);
    headers = headers.set('Tower30-CurrentPassword', currentPassword);
    headers = headers.set('Tower30-NewPassword', password);
    let options: any = { headers: headers};
    options.observe =  'body';

    var url = (this.config.baseApi + AccountSettings.apirest_user_changepassword);

    const bodyRequest = "";
    return this.httpClient.post<any>(url, bodyRequest,
      options,
    );
  }
}
